import { useQueryClient } from '@tanstack/vue-query'

const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.INTERNAL_ORDERS)

const INTERNAL_ORDER_PURPOSES_QUERY_KEY = 'internal-order-purposes' as const
const internalOrderPurposesQueryKey = { ...useQueryKeyFactory(INTERNAL_ORDER_PURPOSES_QUERY_KEY) }

export const apiInternalOrders = {
	fetchInternalOrders: async (page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IInternalOrderResponse[]>(groupPrefix, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(InternalOrderFromJson), meta }
	},

	createInternalOrder: async (payload: IInternalOrderPayload) => {
		const { data } = await apiCommon<IInternalOrderResponse>(groupPrefix, {
			method: 'POST',
			body: payload,
		})
		return InternalOrderFromJson(data)
	},

	updateInternalOrder: async (uuid: string, payload: IInternalOrderPayload) => {
		const { data } = await apiCommon<IInternalOrderResponse>(`${groupPrefix}/${uuid}`, {
			method: 'PUT',
			body: payload,
		})
		return InternalOrderFromJson(data)
	},

	deleteInternalOrder: async (uuid: string) => {
		await apiCommon<string>(`${groupPrefix}/${uuid}`, {
			method: 'DELETE',
		})
	},

	fetchInternalOrderPurposes: async (): Promise<IInternalOrderPurposeOption[]> => {
		const fetchFn = async () => {
			const { data } = await apiCommon<IInternalOrderPurposesResponse>(`${groupPrefix}/purposes`, {
				method: 'GET',
			})

			return data.purposes
		}

		const config = () => ({
			queryKey: internalOrderPurposesQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		const queryClient = useQueryClient()

		const query = config()

		return (
			queryClient.getQueryData<IInternalOrderPurposeOption[]>(query.queryKey) ??
			(await queryClient.fetchQuery(query))
		)
	},
}
